import { ColorPalette } from '@/features/Dashboard/form/AppForm/components/ColorPaletteSelector/const';
import {
  BasicTableValues,
  ChartFormValues,
  TileValues
} from '@/features/Dashboard/form/AppForm/context/types';
import { AppType } from '@/features/Dashboard/types';

export const initialSpotHistoryForm: ChartFormValues = {
  name: 'Spot History chart',
  type: AppType.Spot,
  symbols: {
    active: [],
    backlog: []
  },
  colorPalette: ColorPalette.Vibrant
};

export const initialForwardCurvesForm: ChartFormValues = {
  name: 'Forward Curves chart',
  type: AppType.FWD,
  symbols: {
    active: [],
    backlog: []
  },
  colorPalette: ColorPalette.Vibrant
};

export const initialHighlightedPrices: TileValues = {
  type: AppType.Tiles,
  symbols: {
    active: [],
    backlog: []
  }
};

export const initialTableForm: BasicTableValues = {
  name: 'Data Table',
  type: AppType.Table,
  symbols: {
    active: [],
    backlog: []
  }
};
